import { useService } from "@providersV2";
import { ActivityProgressService } from "@servicesV2";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export type SubmitActivityMutationParam = {
  activityId: string;
};

export function useSubmitActivity(courseId: string, dayId: string) {
  const queryClient = useQueryClient();
  const { initialization: activityProgressServiceInit } = useService(
    ActivityProgressService,
  );

  return useMutation({
    mutationFn: async ({ activityId }: SubmitActivityMutationParam) => {
      const { service: activityProgressService } =
        await activityProgressServiceInit;

      await activityProgressService.submitActivity(courseId, activityId);
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["course", courseId, "outline"],
      });

      queryClient.invalidateQueries({
        queryKey: ["courses", courseId, "dayId", dayId, "learnerId", null],
      });
    },
  });
}
